import React from "react";
import { T } from "../../../context/LanguageContext";

interface OrderSummaryStatsProps {
  selectedCount: number;
  totalCount: number;
}

export function OrderSummaryStats({ selectedCount, totalCount }: OrderSummaryStatsProps) {
  const items = [
    { label: "Selected", count: selectedCount, color: "text-blue-700 bg-blue-50 border-blue-100" },
    { label: "Total", count: totalCount, color: "text-slate-700 bg-slate-50 border-slate-200" },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2 bg-white/70 backdrop-blur-xs px-3 py-1.5 rounded-xl border border-slate-200 shadow-xs text-[11px] select-none font-bold min-h-8">
      {items.map((item, idx) => (
        <React.Fragment key={item.label}>
          {idx > 0 && <span className="h-3 w-px bg-slate-300 hidden sm:inline" />}
          <div className="flex items-center gap-1">
            <span className="text-slate-500"><T>{item.label}</T>:</span>
            <span className={`px-1.5 py-0.5 rounded border font-extrabold ${item.color}`}>
              {item.count}
            </span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default OrderSummaryStats;
